
import { Button } from "@/components/ui/button";
import { EquipamentoSolar } from "@/types";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Edit, Trash2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

interface EquipamentosListProps {
  equipamentos: EquipamentoSolar[];
  tipo: "painel" | "inversor";
  onEdit: (equipamento: EquipamentoSolar) => void;
  onDelete: (id: string, tipo: "painel" | "inversor") => void;
}

export const EquipamentosList = ({ 
  equipamentos, 
  tipo, 
  onEdit, 
  onDelete 
}: EquipamentosListProps) => {
  const title = tipo === "painel" ? "Painéis Cadastrados" : "Inversores Cadastrados";
  const emptyMessage = `Nenhum ${tipo === "painel" ? "painel" : "inversor"} cadastrado.`;
  const potenciaUnit = tipo === "painel" ? "W" : "kW";
  
  return (
    <div>
      <h3 className="font-semibold mb-4">{title}</h3>
      <div className="border rounded-md">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Marca/Modelo</TableHead>
              <TableHead>Potência</TableHead>
              <TableHead>Preço</TableHead>
              <TableHead className="text-right">Ações</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {equipamentos.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} className="text-center py-4 text-muted-foreground">
                  {emptyMessage}
                </TableCell>
              </TableRow>
            ) : (
              equipamentos.map(equipamento => (
                <TableRow key={equipamento.id}>
                  <TableCell>
                    <div className="font-medium">{equipamento.marca}</div>
                    <div className="text-sm text-muted-foreground">{equipamento.modelo}</div>
                  </TableCell>
                  <TableCell>{equipamento.potencia} {potenciaUnit}</TableCell>
                  <TableCell>
                    {equipamento.precoUnitario.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL'
                    })}
                  </TableCell>
                  <TableCell className="text-right">
                    <div className="flex justify-end gap-2">
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => onEdit(equipamento)}
                      >
                        <Edit className="h-4 w-4" />
                      </Button>
                      
                      <AlertDialog>
                        <AlertDialogTrigger asChild>
                          <Button
                            variant="ghost"
                            size="icon"
                            className="text-destructive hover:text-destructive"
                          >
                            <Trash2 className="h-4 w-4" />
                          </Button>
                        </AlertDialogTrigger>
                        <AlertDialogContent>
                          <AlertDialogHeader>
                            <AlertDialogTitle>Confirmar exclusão</AlertDialogTitle>
                            <AlertDialogDescription>
                              Tem certeza que deseja excluir o {tipo === "painel" ? "painel" : "inversor"} {equipamento.marca} {equipamento.modelo}?
                            </AlertDialogDescription>
                          </AlertDialogHeader>
                          <AlertDialogFooter>
                            <AlertDialogCancel>Cancelar</AlertDialogCancel>
                            <AlertDialogAction 
                              onClick={() => onDelete(equipamento.id, tipo)}
                            >
                              Excluir
                            </AlertDialogAction>
                          </AlertDialogFooter>
                        </AlertDialogContent>
                      </AlertDialog>
                    </div>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
